// Distinguishes a phone identifier (always +1XXXXXXXXXX in this app) from an email.
export const isPhoneIdentifier = (identifier) => /^\+/.test(identifier || "");

// The backend rejects an explicit null on either field, so omit the unused one entirely.
export const buildIdentifierFields = (identifier) =>
    isPhoneIdentifier(identifier)
        ? { phone: identifier }
        : { email: identifier };
